var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 971.32,
    height: 520.07,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 971.32 520.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_22",
    x1: 617.17,
    y1: 206.31,
    x2: 343.59,
    y2: 680.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4c2d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#698cad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_27",
    x1: 13718.51,
    y1: 27246.77,
    x2: 13759.02,
    y2: 27246.77,
    gradientTransform: "translate(-4255.73 9218.77) scale(.33 -.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbeb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2a19c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_27-2",
    x1: 13763.86,
    y1: 27354.82,
    x2: 13994.46,
    y2: 27354.82,
    xlinkHref: "#Unbenannter_Verlauf_27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_25",
    x1: 13685.2,
    y1: 27108.2,
    x2: 13795.35,
    y2: 27108.2,
    gradientTransform: "translate(-4255.73 9218.77) scale(.33 -.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_26",
    x1: 13653.61,
    y1: 26647.48,
    x2: 13893.18,
    y2: 26647.48,
    gradientTransform: "translate(-4255.73 9218.77) scale(.33 -.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e8af8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1479f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_25-2",
    x1: 13751.11,
    y1: 27251.49,
    x2: 13926.77,
    y2: 27251.49,
    xlinkHref: "#Unbenannter_Verlauf_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_24",
    x1: 6009.61,
    y1: 22745.06,
    x2: 6039.62,
    y2: 22745.06,
    gradientTransform: "translate(-2137.07 10556.12) scale(.45 -.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81aef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78a9ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_24-2",
    x1: 6039.14,
    x2: 6069.15,
    xlinkHref: "#Unbenannter_Verlauf_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_23",
    x1: 6009.61,
    y1: 22745.06,
    x2: 6039.62,
    y2: 22745.06,
    gradientTransform: "translate(-2137.07 10556.12) scale(.45 -.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78a9ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_23-2",
    x1: 6039.14,
    x2: 6069.15,
    xlinkHref: "#Unbenannter_Verlauf_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_24-3",
    x1: 5951.39,
    x2: 5981.4,
    xlinkHref: "#Unbenannter_Verlauf_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_24-4",
    x1: 5980.92,
    x2: 6010.94,
    xlinkHref: "#Unbenannter_Verlauf_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_23-3",
    x1: 5951.39,
    x2: 5981.4,
    xlinkHref: "#Unbenannter_Verlauf_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_23-4",
    x1: 5980.92,
    x2: 6010.94,
    xlinkHref: "#Unbenannter_Verlauf_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_23-5",
    x1: 5875.33,
    y1: 22782.26,
    x2: 5924.69,
    y2: 22782.26,
    xlinkHref: "#Unbenannter_Verlauf_23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Errorscreen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m796.84,49.85c-.2,0-.5-.1-.6-.4-2.4-4.6-4.9-9.1-7.4-13.5-.2-.3-.1-.7.2-.9.3-.2.7-.1.9.2,2.5,4.4,5,8.9,7.4,13.5.2.3,0,.7-.3.9,0,.2-.1.2-.2.2Z",
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m837.49,254.85c-20.22-4.32-41.86,2.05-63.04-1.18-28.07-4.29-56.71-13.23-80.63-28.73-38.95-25.24-75.42-60.53-123.44-68.22-76.54-12.27-135.17,41.66-205,55.63-70.31,14.07-141.89-52.02-204.17,4.3-63.56,57.47-29.47,174.13,13.98,234.05,32.36,44.64,66.26,66.98,120.28,68.06,65.63,1.31,126.86-6.74,189.84-26.27,95.68-29.67,196.69-67.97,281.93-121.45,22.92-14.38,102.73-72.8,70.24-116.17Z",
    fill: "#ec8365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,386.39h29.4v95.4H0v-95.4Zm37.94,0h30.06l27.79,51.04h.27v-51.04h27.79v95.4h-28.59l-29.26-52.11h-.27v52.11h-27.79v-95.4Zm94.59,0h73.75v24.45h-44.36v11.89h38.08v22.71h-38.08v36.34h-29.4v-95.4Zm123.05-2.27c28.99,0,48.37,20.84,48.37,49.97s-19.38,49.97-48.37,49.97-48.37-20.84-48.37-49.97,19.37-49.97,48.37-49.97Zm0,76.16c7.48,0,18.97-4.94,18.97-26.19s-11.49-26.19-18.97-26.19-18.97,4.94-18.97,26.19,11.49,26.19,18.97,26.19Zm53.97-73.89h41.82l13.63,56.12h.27l13.63-56.12h41.82v95.4h-27.79v-61.2h-.27l-16.57,61.2h-21.91l-16.57-61.2h-.27v61.2h-27.79v-95.4Zm146.03,0h28.73l34.74,95.4h-30.46l-4.01-13.63h-30.33l-4.28,13.63h-29.53l35.14-95.4Zm23.12,61.33l-8.55-29.4h-.27l-9.22,29.4h18.04Zm53.44-36.88h-26.72v-24.45h82.84v24.45h-26.72v70.95h-29.4v-70.95Zm60.26-24.45h78.97v24.45h-49.57v11.89h45.03v22.71h-45.03v11.89h51.04v24.45h-80.44v-95.4Zm87.38,0h55.98c16.57,0,31.13,9.22,31.13,27.26,0,9.89-4.54,20.31-14.3,23.92,8.02,3.07,12.96,11.89,14.03,23.78.4,4.54.4,16.3,3.21,20.44h-29.4c-1.47-4.81-2-9.75-2.41-14.7-.67-9.09-1.6-18.57-13.23-18.57h-15.63v33.27h-29.4v-95.4Zm29.4,41.69h15.37c5.48,0,12.96-.94,12.96-9.49,0-6.01-3.34-9.49-14.56-9.49h-13.76v18.97Zm62.93-41.69h29.4v95.4h-29.4v-95.4Zm64.27,0h28.73l34.74,95.4h-30.46l-4.01-13.63h-30.33l-4.28,13.63h-29.53l35.14-95.4Zm23.11,61.33l-8.55-29.4h-.27l-9.22,29.4h18.04Zm40.21-61.33h29.4v70.95h42.22v24.45h-71.62v-95.4Z",
    fill: "url(#Unbenannter_Verlauf_22)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shoes_4_-i0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "R_shoe_4_-i0",
    d: "m231.19,474l-16.92,21.41,61.61,20.74s-1.11-7.16-10.12-15.21c-9.01-8.06-14.46-20.16-14.46-20.16l-20.11-6.77",
    fill: "#151a4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m292.02,183.01c2.6,3.91,3.62,8.85,2.77,13.47,3.07-2.18,6.84-3.08,10.51-3.93-2.3-5.24-1.65-11.24-.95-16.92-1.96,1.11-3.77,2.48-5.35,4.09-.94.95-1.81,1.98-2.9,2.76-1.09.78-2.45,1.29-3.76,1.01,1.08.64-1.02-1.53-.33-.48Z",
    fill: "url(#Unbenannter_Verlauf_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.37,205.02c-1.41-.82-3-1.4-4.63-1.41-3.51-.01-6.57,2.68-8.1,5.84-1.53,3.16-1.85,6.75-2.25,10.24-2.51,22.21-4.81,26.04-13.55,46.9-1.79,4.28-9.77,27.04-12.28,30.94-5.72,8.91-6.07,8.24-6.3,8.42-4.1,3.17-11.62,3.27-15.44,6.77-.94,3.99-1.72,8.88-1.48,12.39.17,1.51,3.48.68,5.32.7,1.36.01,2.81,0,3.97-.71,1.16-.71,1.84-2.39,1.02-3.48-1.44.41-2.88.82-4.33,1.23-.23-2.58-.19-5.71,2.02-7.05,1.09-.66,2.44-.67,3.71-.83,6.8-.86,8.73-1.71,11.17-6.31,2.15-4.07,21.87-23.91,26.01-31.96,6.67-12.98,13.09-34.51,19.1-47.81,1.56-3.45,3.15-7.02,3.27-10.81.18-5.22-2.71-10.44-7.24-13.06Z",
    fill: "#ffbeb6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.73,160.3c1.45,1.32,4.28.09,5.47,1.65-1,3.7.59,10.16-.9,15.04-1.03,3.39-4.26,5.76-7.69,6.64-3.43.87-7.05.48-10.54-.14-1.53-.27-3.09-.6-4.42-1.41-1.42-.87-2.47-2.23-3.34-3.65-2.38-3.93-3.55-8.57-3.32-13.16.15-2.89.94-5.92,3.04-7.92.92-.88,2.06-1.52,3.23-2.04,3.01-1.34,6.4-1.95,9.64-1.37,3.24.59,6.31,2.44,8.03,5.25.24.39.46.8.79,1.1Z",
    fill: "#ffbeb6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.37,158.85c1.73-.72,3.68.12,5.29,1.09,7.52,4.51,10.96,10.86,14.9,18.51.66,1.28,2.14,4.64,1.37,5.86-.81,1.29-3.57,2.1-5.05,2.44-3.9.89-8.53,1.59-11.44-1.15-.8-.75-1.38-1.71-1.88-2.68-3.72-7.25-3.33-15.83-2.85-23.95.92,1.18-1.26-1.29-.35-.11Z",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.44,114.96c-.56-.13-1.1.23-1.55.59-.08.07-.16.14-.24.21.37-.5.73-1,1.08-1.5.38-.54.78-1.11.86-1.77.08-.66-.26-1.42-.91-1.57-.56-.13-1.1.23-1.55.59-.07.06-.14.12-.22.18-.01-.1-.03-.2-.04-.3.29-.39.57-.79.85-1.18.38-.54.78-1.11.86-1.77.08-.66-.26-1.42-.91-1.57-.56-.13-1.1.23-1.55.59-.1.08-.2.17-.3.25.13-.18.26-.36.38-.53.38-.54.78-1.11.86-1.77.08-.66-.26-1.42-.91-1.57-.56-.13-1.1.23-1.55.59-.48.39-.94.8-1.37,1.23-.07-.07-.14-.13-.21-.2,2.69-4.64,9.4-11.82,6.56-14.63-1.31-1.3-5.8,8.58-9.84,14.63-.91-.05-6.21,13.61-7.82,17.15-1.49,3.29-15.23,21.17-17.16,24.22-10.14,16.03-14.86,18.45-19.17,25.23-4.9,7.71-19.3,9.94-21.34,18.84-.56,2.44-.33,4.97-.1,7.46.43,4.67,1.87,10.5,6.5,11.29,4.35.74,7.59-3.65,10.45-7,4.15-4.85,5.7-3.72,10.54-7.88,14.49-12.45,21.22-21.57,26.74-39.86,1.34-4.43,7.31-23.98,10.6-27.24,1.47-1.46,4.68-1.14,5.9-2.82.33-.46.72-1.3,1.08-2.3.44-.41.86-.85,1.26-1.32-.06,1.66-.13,3.33-.19,4.99,0,.23-.02.47.08.68.27.59,1.21.55,1.65.07s.53-1.17.59-1.82c.26-2.65.52-5.3.77-7.95.1-.22.17-.46.21-.7.08-.65-.27-1.42-.91-1.56Z",
    fill: "url(#Unbenannter_Verlauf_27-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.46,414.81c-3.01,6.32-12.34,10.61-15.89,16.65-8.89,15.12-6.59,25.8-10.65,42.86,5.92,2.43,20.78,7.14,20.78,7.14,0,0,2.51-3.38,3.86-4.89,51.48-57.17,83.41-127.76,92.97-204.09-7.31.46-13.13-.97-20.44-.5-1.45.09-2.93-.47-4.14.33-1.11.73-1.8,1.92-2.44,3.08-12.35,22.19-21.7,46.05-27.7,70.72-2.34,9.63-4.4,19.84-10.83,27.38-4.77,5.59-11.04,12.93-15.68,18.63-5.77,7.08-5.91,14.47-9.84,22.71Z",
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.95,212.72c-4.76-4.12-9.52-8.25-14.28-12.37-2.41.78-3.97,3.19-4.54,5.65-.57,2.46-.33,5.03-.25,7.56.44,13.15-3.49,26.4-11.03,37.18,4.4,1.38,8.79,2.76,13.19,4.14,4.73,1.49,10.26,3.85,11.04,8.74,1.26-11.29,4.5-22.36,9.52-32.56,1.46-2.98,3.13-6.13,2.69-9.42-.5-3.71-3.51-6.49-6.34-8.94Z",
    fill: "url(#Unbenannter_Verlauf_25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.54,228.47c1.22,11.62,2.01,23.29,2.37,34.98-1.91-3.59-6.11-5.83-10.16-5.42.22-.66.45-1.33.67-1.99",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 22.06,
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("g", {
    id: "shoes_3_-i0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "R_shoe_3_-i0",
    d: "m275.83,494.38l-9.21,25.69h65.01s-3.33-6.43-14.44-11.19c-11.11-4.76-20.14-14.5-20.14-14.5h-21.22",
    fill: "#23286b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m293.38,393.15c2.45-8.87,15.54-56.29,8.47-63.88-12.61-13.53-2.73-44.22,4.8-50.68,0,0,26.31-6.82,43.14-4.54-10.59,149.08-40.03,169.26-51.48,221.77-10-.4-13.01.29-22.77-.02-.46-.02-8.31-22.43-3.75-34,1.63-4.13,6.74-16.66,8.33-20.81,4.28-11.18,0-9.49,1.39-21.5,1.32-11.39,8.86-15.41,11.87-26.33Z",
    fill: "url(#Unbenannter_Verlauf_26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.22,189.51c2.67-.49,4.07-2.19,4.07-2.19,0,0,15.79,2.53,20.82,7.31,8.68,8.25,11.71,16.64,16.2,27.74,6.96,17.18,9.75,44.81,8.48,55.47-15.14-3.78-23.2,12.81-52.22,3.78,9.08-28.76,8.86-47.86-2.19-63.6-3.38-4.81-5-11.07-5.76-16.89-.76-5.83,5.13-11.74,5.13-11.74,0,0,2.23.71,5.47.12Z",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.13,186.96c-2.98,2.77-.63,6.44.88,10.22,1.51,3.78,4.64,6.7,7.99,9.01,3.67,2.53,7.96,4.55,12.41,4.33,5.37-.26,10.02-3.67,14.2-7.05,7.42-6,14.54-12.38,21.31-19.11-16.87-7.5-17.07-15.49-21.73-25.91-6.56,7.06-28.29,21.54-35.07,28.51Z",
    fill: "url(#Unbenannter_Verlauf_25-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.38,182.34c.99,1.24,3.42,2.4,4.82,3.15,3.45,1.84,7.43.01,9.75-3.14.68-.93,1.27-2.08.95-3.19-.26-.91-1.05-1.54-1.56-2.33-.78-1.19-.87-2.8-.24-4.07,1.35-2.74,5.48-3.64,6.02-6.64.38-2.15-1.39-4.29-.88-6.41.45-1.9,2.48-2.9,4.29-3.65-1.31-1.46-4.65-2.34-6.61-2.41-3.68-.12-6.25.6-9.8,1.61-3.54,1.01-6.91,3.07-8.82,6.22-1.89,3.11-2.19,6.92-2.1,10.56.04,1.68.43,5.18,1.18,6.68.38.76,2.07,2.46,3,3.63Z",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.36,186.36c-.68-1.41-1.62-2.89-3.13-3.29-.87-.23-1.8-.06-2.67.18-7.34,1.97-12.96,8.02-16.61,14.68-3.66,6.66-5.72,14.05-8.58,21.09-.63,1.55-1.06,4.84-1.06,4.84,0,0,5.34,3.87,8.85,4.28,6.83.8,13.21,1.22,19.74-.94-1.4-3.58-1.18-7.76.59-11.17,1.28-2.47,3.3-4.51,4.5-7.02,1.02-2.12,1.42-4.5,1.55-6.85.3-5.42-.81-10.91-3.18-15.79Z",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297,193.3c-.15,0-.29-.08-.37-.22-1.15-2.18-2.21-4.5-1.59-6.79.22-.81.64-1.52,1.04-2.22.38-.66.74-1.28.94-1.97.45-1.58-.01-3.2-.51-4.92-.4-1.4-.82-2.84-.73-4.31.09-1.41.64-2.71,1.17-3.97.5-1.2.98-2.33,1.09-3.55.09-.97-.06-1.94-.22-2.96-.11-.67-.21-1.36-.25-2.05-.09-1.69.46-3.95,2.29-4.74.21-.09.45,0,.55.22.09.21,0,.45-.22.55-1.44.62-1.86,2.51-1.79,3.94.03.65.14,1.32.24,1.97.16,1.03.33,2.09.23,3.17-.12,1.34-.65,2.59-1.16,3.79-.53,1.25-1.02,2.43-1.1,3.7-.08,1.33.31,2.7.7,4.03.51,1.75,1.03,3.57.51,5.38-.22.78-.63,1.48-1.02,2.15-.39.68-.76,1.32-.95,2.02-.55,2,.41,4.07,1.52,6.19.11.2.03.45-.17.56-.06.03-.13.05-.19.05Z",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.57,223s-.07,0-.1-.01c-.22-.06-.36-.28-.3-.5,2.91-11.68,4.45-16.15,9.77-25.38,2.45-4.25,7.16-9.8,11.7-11.92,2.85-1.33,5.34-1.95,8.89-2.21.22-.02.43.16.45.38.02.23-.16.43-.38.45-3.44.25-5.85.85-8.6,2.14-4.18,1.96-8.87,7.31-11.34,11.58-5.31,9.21-6.76,13.4-9.69,25.16-.05.19-.22.31-.4.31Z",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.04,
    y: 180.77,
    width: 4.04,
    height: 4.04,
    transform: "translate(-30.74 307.25) rotate(-55.59)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629.35,328.06l-4.71-12.85c-1.7-.08-3.37.1-5,.65l5.1,13.9c.29.78-.11,1.64-.89,1.93-.78.29-1.64-.11-1.93-.89l-5-13.64c-1.52.95-2.82,2.2-3.88,3.68l4.22,11.51c.29.78-.11,1.64-.9,1.93-.78.29-1.64-.11-1.93-.89l-3.32-9.04c-1.9,4.71-2.01,10.67.13,16.53.05.14.1.27.15.41-1.1.64-2.18,1.32-3.21,2.08-2.9,2.13-6.64,5.74-7.98,10.86l1.45.38c1.23-4.69,4.71-8.04,7.42-10.03.93-.68,1.91-1.31,2.91-1.89,2.25,4.99,5.85,8.86,9.89,11.01l-3.15-8.59c-.29-.78.11-1.64.89-1.93.78-.29,1.64.11,1.93.9l4.06,11.07c1.77.44,3.57.53,5.32.24l-4.72-12.86c-.29-.78.11-1.64.89-1.93.78-.29,1.64.11,1.93.9l4.78,13.03c1.54-.68,2.92-1.7,4.15-2.96l-4.32-11.77c-.29-.78.11-1.64.89-1.93.78-.29,1.64.11,1.93.89l3.71,10.12c1.2-1.7,2.24-3.61,3.18-5.6l-2.33-6.35c-.29-.78.11-1.64.89-1.93.78-.29,1.64.11,1.93.9l1.24,3.38c2.29-5.69,3.92-11.12,5.83-12.93-3.24-.68-7.86-3.78-12.97-6.54l1.61,4.38c.29.78-.11,1.64-.9,1.93-.78.29-1.64-.11-1.93-.9l-2.71-7.38c-1.98-.9-4-1.66-6.01-2.12l4.15,11.33c.29.78-.11,1.64-.89,1.93-.77.29-1.64-.11-1.92-.89Z",
    fill: "#e0ebfe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.66,
    y: 69.77,
    width: 61.76,
    height: 14.6,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.86,
    y: 59.89,
    width: 61.76,
    height: 10.04,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 72.83,
    width: 57.99,
    height: 8.48,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 79.24,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 77.1,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 74.97,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 72.83,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.24,
    y: 45.06,
    width: 72.86,
    height: 14.6,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.24,
    y: 48.13,
    width: 68.41,
    height: 8.48,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.24,
    y: 54.54,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.24,
    y: 52.4,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.24,
    y: 50.26,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.24,
    y: 48.13,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.75,
    y: 341.75,
    width: 61.76,
    height: 14.6,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.95,
    y: 331.87,
    width: 61.76,
    height: 10.04,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.99,
    y: 344.81,
    width: 57.99,
    height: 8.48,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.99,
    y: 351.23,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.99,
    y: 349.09,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.99,
    y: 346.95,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.99,
    y: 344.81,
    width: 57.99,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.33,
    y: 317.05,
    width: 72.86,
    height: 14.6,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.33,
    y: 320.11,
    width: 68.41,
    height: 8.48,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.33,
    y: 326.52,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.33,
    y: 324.39,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.33,
    y: 322.25,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.33,
    y: 320.11,
    width: 68.41,
    height: 1.07,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.72,
    y: 84.5,
    width: 218.67,
    height: 4.56,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.34,
    y: 357.48,
    width: 218.67,
    height: 4.56,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.7,
    width: 18.26,
    height: 84.37,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.27,
    y: 18.35,
    width: 11.59,
    height: 66.47,
    transform: "translate(15.57 190.49) rotate(-20.22)",
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.53,
    y: 18.35,
    width: 11.59,
    height: 66.47,
    transform: "translate(16.32 194.73) rotate(-20.22)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.8,
    y: 19.34,
    width: 11.58,
    height: 66.47,
    transform: "translate(39.51 267.72) rotate(-27.32)",
    fill: "#78a9ef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.8,
    y: 234.7,
    width: 66.47,
    height: 11.59,
    transform: "translate(132.33 670.72) rotate(-69.78)",
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.54,
    y: 234.7,
    width: 66.47,
    height: 11.59,
    transform: "translate(124.3 659.22) rotate(-69.78)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.97,
    y: 105.95,
    width: 11.89,
    height: 73.02,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.67,
    y: 100.89,
    width: 18.49,
    height: 78.08,
    fill: "#23286b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.54,
    y: 100.3,
    width: 10.74,
    height: 73.31,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.66,
    y: 100.3,
    width: 1.35,
    height: 73.31,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.95,
    y: 100.3,
    width: 1.35,
    height: 73.31,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.25,
    y: 100.3,
    width: 1.35,
    height: 73.31,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.54,
    y: 100.3,
    width: 1.35,
    height: 73.31,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.41,
    y: 92.83,
    width: 17.29,
    height: 86.14,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.25,
    y: 296.88,
    width: 9.75,
    height: 59.86,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.86,
    y: 286.12,
    width: 14.18,
    height: 70.62,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.81,
    width: 18.26,
    height: 84.37,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.68,
    y: 119.8,
    width: 13.1,
    height: 60.53,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.52,
    y: 121.81,
    width: 10.21,
    height: 58.6,
    transform: "translate(-23.17 128.02) rotate(-15.15)",
    fill: "#78a9ef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.99,
    y: 155.19,
    width: 10.21,
    height: 2.7,
    transform: "translate(-24.54 128.59) rotate(-15.15)",
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.68,
    y: 158.24,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.68,
    y: 165.99,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.62,
    y: 119.8,
    width: 13.1,
    height: 60.53,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.62,
    y: 158.24,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.62,
    y: 165.99,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.55,
    y: 119.8,
    width: 13.1,
    height: 60.53,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.55,
    y: 158.24,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.55,
    y: 165.99,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.67,
    y: 294.1,
    width: 13.83,
    height: 63.93,
    transform: "translate(-44.43 79.96) rotate(-8.88)",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.33,
    y: 334.58,
    width: 13.83,
    height: 4.18,
    transform: "translate(-46.05 80.34) rotate(-8.88)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.6,
    y: 342.66,
    width: 13.83,
    height: 4.18,
    transform: "translate(-47.28 80.63) rotate(-8.88)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.7,
    y: 294.1,
    width: 13.83,
    height: 63.93,
    transform: "translate(-44.23 82.58) rotate(-8.88)",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.36,
    y: 334.58,
    width: 13.83,
    height: 4.18,
    transform: "translate(-45.85 82.97) rotate(-8.88)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.63,
    y: 342.66,
    width: 13.83,
    height: 4.18,
    transform: "translate(-47.08 83.26) rotate(-8.88)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.73,
    y: 294.1,
    width: 13.83,
    height: 63.93,
    transform: "translate(-44.02 85.21) rotate(-8.88)",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.39,
    y: 334.58,
    width: 13.83,
    height: 4.18,
    transform: "translate(-45.64 85.6) rotate(-8.88)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.65,
    y: 342.66,
    width: 13.83,
    height: 4.18,
    transform: "translate(-46.87 85.89) rotate(-8.88)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.66,
    y: 119.8,
    width: 13.1,
    height: 60.53,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.66,
    y: 158.24,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.66,
    y: 165.99,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.6,
    y: 119.8,
    width: 13.1,
    height: 60.53,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.6,
    y: 158.24,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.6,
    y: 165.99,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.54,
    y: 119.8,
    width: 13.1,
    height: 60.53,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.54,
    y: 158.24,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.54,
    y: 165.99,
    width: 13.1,
    height: 3.96,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.5,
    y: 221.42,
    width: 11.42,
    height: 52.78,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.5,
    y: 248.52,
    width: 11.42,
    height: 6.91,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.5,
    y: 261.69,
    width: 11.42,
    height: 3.45,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.4,
    y: 221.42,
    width: 11.42,
    height: 52.78,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.4,
    y: 248.52,
    width: 11.42,
    height: 6.91,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.4,
    y: 261.69,
    width: 11.42,
    height: 3.45,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.3,
    y: 221.42,
    width: 11.42,
    height: 52.78,
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.3,
    y: 248.52,
    width: 11.42,
    height: 6.91,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.3,
    y: 261.69,
    width: 11.42,
    height: 3.45,
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.7,
    y: 22.73,
    width: 18.26,
    height: 38.92,
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.81,
    y: 22.73,
    width: 18.26,
    height: 38.92,
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 214.97,
    width: 12.75,
    height: 58.91,
    fill: "#23286b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.77,
    y: 214.69,
    width: 12.75,
    height: 58.91,
    transform: "translate(-13.27 25.08) rotate(-3.28)",
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 230.83,
    width: 12.75,
    height: 27.17,
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.79,
    y: 214.97,
    width: 12.75,
    height: 58.91,
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.79,
    y: 230.83,
    width: 12.75,
    height: 27.17,
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.77,
    y: 230.56,
    width: 12.75,
    height: 27.18,
    transform: "translate(-13.27 25.08) rotate(-3.28)",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.01,
    y: 214.33,
    width: 12.75,
    height: 58.91,
    transform: "translate(-29.13 63.31) rotate(-7.86)",
    fill: "#d62929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.01,
    y: 230.19,
    width: 12.75,
    height: 27.17,
    transform: "translate(-29.13 63.31) rotate(-7.86)",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.27,
    y: 210.33,
    width: 13.62,
    height: 62.95,
    fill: "url(#Unbenannter_Verlauf_24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.67,
    y: 210.33,
    width: 13.62,
    height: 62.95,
    fill: "url(#Unbenannter_Verlauf_24-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.27,
    y: 227.29,
    width: 13.62,
    height: 29.04,
    fill: "url(#Unbenannter_Verlauf_23)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.67,
    y: 227.29,
    width: 13.62,
    height: 29.04,
    fill: "url(#Unbenannter_Verlauf_23-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.85,
    y: 210.33,
    width: 13.62,
    height: 62.95,
    fill: "url(#Unbenannter_Verlauf_24-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.25,
    y: 210.33,
    width: 13.62,
    height: 62.95,
    fill: "url(#Unbenannter_Verlauf_24-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.85,
    y: 227.29,
    width: 13.62,
    height: 29.04,
    fill: "url(#Unbenannter_Verlauf_23-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.25,
    y: 227.29,
    width: 13.62,
    height: 29.04,
    fill: "url(#Unbenannter_Verlauf_23-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.72,
    y: 178.95,
    width: 218.67,
    height: 4.56,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.16,
    y: 250.65,
    width: 6,
    height: 11.59,
    transform: "translate(113.51 675.64) rotate(-69.78)",
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529.33 238.57 540.2 242.57 551.73 211.31 540.86 207.31 529.33 238.57",
    fill: "url(#Unbenannter_Verlauf_23-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.72,
    y: 273.41,
    width: 218.67,
    height: 4.56,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.44,357.34c-.06,0-.13,0-.19-.03-.37-.1-.58-.49-.47-.85,4.56-16.02,10.34-31.9,17.18-47.21.15-.35.56-.51.91-.35.35.15.5.56.35.91-6.81,15.24-12.57,31.06-17.12,47.02-.09.3-.36.5-.66.5Z",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 606.48,
    cy: 308.08,
    rx: 3.19,
    ry: 8.54,
    transform: "translate(79.91 738.73) rotate(-66.21)",
    fill: "#1c2868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606.42,308.37c-.1,0-.19-.02-.28-.06-.35-.16-.5-.57-.34-.91,3.9-8.6,8.21-17.16,12.79-25.42.19-.33.6-.45.94-.27.33.18.45.6.27.94-4.57,8.23-8.85,16.76-12.74,25.32-.12.25-.37.4-.63.4Z",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.3,
    cy: 280.43,
    rx: 3.84,
    ry: 10.29,
    transform: "translate(160.07 782.02) rotate(-71.79)",
    fill: "#1c2868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m620.41,280.82c-.12,0-.23-.03-.34-.09-.33-.19-.45-.61-.26-.94,3.85-6.82,7.96-13.58,12.22-20.1.21-.32.64-.41.95-.2.32.21.41.64.2.95-4.25,6.49-8.35,13.23-12.18,20.02-.13.23-.36.35-.6.35Z",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 634.55,
    cy: 258.33,
    rx: 3.85,
    ry: 10.28,
    transform: "translate(51.99 618.91) rotate(-53.91)",
    fill: "#1c2868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.39,258.06c-.13,0-.26-.04-.38-.12-.32-.21-.4-.64-.19-.96,3.3-4.94,6.77-9.86,10.32-14.63.23-.31.66-.37.96-.14.31.23.37.66.14.96-3.53,4.75-6.99,9.65-10.27,14.57-.13.2-.35.31-.58.31Z",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.58,
    cy: 240.31,
    rx: 5.16,
    ry: 13.79,
    transform: "translate(71.51 621.23) rotate(-53.91)",
    fill: "#1c2868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.12,240.23c-.15,0-.29-.05-.42-.14-.3-.23-.36-.66-.13-.96,2.4-3.16,4.89-6.31,7.39-9.37.24-.3.68-.34.97-.1.3.24.34.68.1.97-2.49,3.05-4.97,6.18-7.37,9.33-.13.18-.34.27-.55.27Z",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m655.29,280.98l-5.79-7.66c-1.15.3-2.23.77-3.2,1.47l6.26,8.28c.35.46.26,1.13-.2,1.48s-1.12.26-1.47-.2l-6.14-8.12c-.81.95-1.43,2.06-1.83,3.28l5.18,6.85c.35.46.26,1.13-.2,1.48s-1.12.26-1.47-.2l-4.07-5.38c-.3,3.56.85,7.59,3.49,11.08.06.08.12.16.19.24-.61.66-1.18,1.34-1.71,2.07-1.5,2.03-3.25,5.24-3.08,8.96l1.05-.05c-.15-3.41,1.48-6.38,2.88-8.28.48-.65,1-1.28,1.55-1.88,2.53,2.88,5.73,4.74,8.86,5.34l-3.87-5.11c-.35-.46-.26-1.13.2-1.48.46-.35,1.12-.26,1.47.2l4.99,6.59c1.27-.07,2.49-.38,3.6-.94l-5.79-7.66c-.35-.46-.26-1.13.2-1.48s1.12-.26,1.47.2l5.87,7.76c.89-.78,1.59-1.75,2.16-2.85l-5.3-7.01c-.35-.46-.26-1.13.2-1.48s1.12-.26,1.47.2l4.56,6.03c.45-1.39.75-2.9.97-4.42l-2.86-3.78c-.35-.46-.26-1.13.2-1.48s1.12-.26,1.47.2l1.52,2.01c.36-4.3.32-8.28,1.22-9.9-2.3.22-6.02-.91-10-1.7l1.97,2.61c.35.46.26,1.13-.2,1.48s-1.12.26-1.47-.2l-3.32-4.39c-1.51-.19-3.01-.28-4.45-.18l5.1,6.75c.35.46.26,1.13-.2,1.48-.46.35-1.12.26-1.47-.2Z",
    fill: "#dbecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.07,360.43c-.06.02-.13.03-.2.03-.33,0-.59-.26-.58-.59.08-6.62-.04-13.36-.16-19.87-.24-13.47-.48-27.39.98-41.03,2.55-23.79,10.12-42.64,22.51-56.03.22-.24.59-.26.83-.04.24.22.25.59.03.83-12.21,13.2-19.68,31.83-22.2,55.36-1.45,13.56-1.21,27.45-.97,40.89.11,6.52.23,13.27.16,19.91,0,.25-.17.47-.39.55Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610.13,272.92c-.05.02-.1.03-.16.03l-19.09,1.26c-.32.02-.6-.22-.62-.54-.02-.32.22-.6.55-.62l19.09-1.26c.32-.02.6.22.62.54.02.27-.15.5-.39.59Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m611.27,268.2c-.05.02-.1.03-.16.03l-18.78,1.24c-.32.02-.6-.22-.62-.54-.02-.32.22-.6.55-.62l18.78-1.24c.32-.02.6.22.62.54.02.27-.15.5-.39.59Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m612.42,263.47c-.05.02-.1.03-.16.03l-17.47,1.15c-.33.02-.6-.22-.62-.54-.02-.32.23-.6.55-.62l17.47-1.15c.32-.02.6.22.62.54.02.27-.15.5-.39.59Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613.57,258.75c-.05.02-.1.03-.16.03l-16.31,1.08c-.32.02-.6-.22-.62-.54s.22-.6.55-.62l16.31-1.08c.32-.02.6.22.62.54.02.27-.15.5-.39.59Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m614.72,254.02c-.05.02-.1.03-.16.03l-14.92.98c-.32.02-.6-.22-.62-.54-.02-.32.22-.6.55-.62l14.92-.98c.32-.02.6.22.62.54.02.27-.15.5-.39.59Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615.87,249.29c-.05.02-.1.03-.16.03l-12.73.84c-.33.02-.6-.22-.62-.54-.02-.32.23-.6.55-.62l12.73-.84c.32-.02.6.22.62.54.02.27-.15.5-.39.59Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m617.02,244.57c-.05.02-.1.03-.16.03l-10.06.66c-.32.02-.6-.22-.62-.54-.02-.32.22-.6.55-.62l10.06-.66c.32-.02.6.22.62.54.02.27-.15.5-.39.59Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m590.85,274.18c-.25.09-.53,0-.68-.22l-10.61-15.75c-.18-.27-.11-.63.16-.81.27-.18.64-.11.82.16l10.61,15.75c.18.27.11.63-.16.81-.04.03-.09.05-.13.07Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m592.88,268.82c-.25.09-.53,0-.68-.22l-9.54-14.16c-.18-.27-.11-.63.16-.81.27-.18.64-.11.82.16l9.54,14.16c.18.27.11.63-.16.81-.04.03-.09.05-.13.07Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.09,263.74c-.25.09-.53,0-.68-.22l-8.66-12.86c-.18-.27-.11-.63.16-.81.27-.18.64-.11.82.16l8.66,12.86c.18.27.11.63-.16.81-.04.03-.09.05-.13.07Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.4,258.79c-.25.09-.53,0-.68-.22l-7.88-11.69c-.18-.27-.11-.63.16-.81.27-.18.64-.11.82.16l7.88,11.69c.18.27.11.63-.16.81-.04.03-.09.05-.13.07Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.02,254.31c-.25.09-.53,0-.68-.22l-7.41-10.99c-.18-.27-.11-.63.16-.81.27-.18.64-.11.82.16l7.41,10.99c.18.27.11.63-.16.81-.04.03-.09.05-.13.07Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.78,250.05c-.25.09-.53,0-.68-.22l-7.08-10.5c-.18-.27-.11-.63.16-.81.27-.18.64-.11.82.16l7.08,10.5c.18.27.11.63-.16.81-.04.03-.09.05-.13.07Z",
    fill: "#c4d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.95,246.38c-.25.09-.53,0-.68-.22l-7.15-10.61c-.18-.27-.11-.63.16-.81.27-.18.64-.11.82.16l7.15,10.61c.18.27.11.63-.16.81-.04.03-.09.05-.13.07Z",
    fill: "#c4d9f8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e7eba06672817e89bfb0524f4ba6888b.svg";
export { ForwardRef as ReactComponent };